<template>

</template>

<script>
import SlideSequence from '../models/slide-sequence';

import Vue from 'vue';

// https://github.com/dgrubelic/vue-authenticate
// vue-authenticate options
import VueAuthenticate from 'vue-authenticate';
Vue.use(VueAuthenticate, {
  baseUrl: window.location.origin, // Your API domain

  providers: {
    twitter: {
      name: 'twitter',
      url: '/api/AuthTwitter',
      authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
      // https://github.com/sahat/satellizer#question-can-i-change-redirecturi-to-something-other-than-base-url
      redirectUri: window.location.origin + '/api/ValidateTwitter',
      oauthType: '1.0',
      popupOptions: { 
        width: 495, 
        height: 645
      },
    },
  }
});

// https://github.com/renoguyon/vue-jwt
import VueJWT from 'vuejs-jwt';
Vue.use(VueJWT, {
  storage: 'localStorage',
  keyName: 'vue-authenticate.vueauth_token'
});

// https://github.com/pinguinjkeke/vue-local-storage
import VueLocalStorage from 'vue-localstorage';
Vue.use(VueLocalStorage);

import axios from 'axios';

export default {
  name: "CreateBase",
  
  components: {

  },

  data: function() {
    return {
      steps: [
        {'step': 'upload'},
        {'step': 'edit'},
        {'step': 'tweet'}
      ],
      currentStep: null,
      slideSequence: null,
      tweetSequence: null
    };
  },

  computed: {
    currentStepNum() {
      if (this.steps && this.currentStep) {
        return this.steps.findIndex(step => step === this.currentStep);
      }
      return 0;
    }
  },

  methods: {
    goToUploadStep() {
      console.log('Create > Upload step');
      this.$appInsights.trackPageView('/create/upload');
      this.$ga.page({ page: '/create/upload', title: 'Create > Upload' });

      this.currentStep = this.steps[0];
    },

    goToEditStep(uploadResponse) {     
      console.log('Create > Edit step', uploadResponse);
      this.$appInsights.trackPageView('/create/edit', window.location, { 'fileId': uploadResponse.fileId });
      this.$ga.page({ page: '/create/edit', title: 'Create > Edit' });

      let slideSequence = new SlideSequence(uploadResponse);
      this.slideSequence = slideSequence;
      this.currentStep = this.steps[1];
    },

    goToTweetStep(tweetSequence) {     
      console.log('goToTweetStep', tweetSequence);
      this.$appInsights.trackPageView('/create/tweet', window.location, { 'fileId': tweetSequence.fileId });
      this.$ga.page({ page: '/create/tweet', title: 'Create > Tweet' });

      this.tweetSequence = tweetSequence;
      this.currentStep = this.steps[2];
    }
  },

  mounted() {
    // Ping Upload function to wake it up, ready for file upload
    axios.get('/api/UploadPing');

    this.goToUploadStep();
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/CreateBase.vue